import React from "react"

import {FieldViewGroupProps} from "../../../../../render/group/@type"

// const debug = "FieldDate_ViewGroup"
const debug = false

export default function FieldDate_ViewGroup(props: FieldViewGroupProps) {

    const value = props.field.getViewValue(props.model)

    debug && console.log(debug, 'render', value)

    const classes       = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)
    const iconClasses   = Classes('ui5-ico-13', props.field.icon)

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <div className={iconClasses}/>
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">{props.field.groupLabel(value, props.groupBy)}</div>
        </div>
    )
}



